import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import EmployeeProfile from "../EmployeeRegister/EmployeeProfile";
import PersonalDetail from "../EmployeeRegister/PersonalDetail";
import {
  main_url,
  getUserId,
  getMainRole,
  getWorkFlowStatus,
  getCookieData,
  getPermissionStatus,
  startSaving,
  calculationWorkingExp,
  validatePhoneNumberInput,
  validatePhoneNumber,
  validateEmailAddress,
} from "../../../utils/CommonFunction";

import EducationDetails from "../EmployeeRegister/EducationDetails";
import ContactDetails from "../EmployeeRegister/CoantactDetails";
import BankAccountDetails from "../EmployeeRegister/BankAcocuntDetails";
import OtherInfo from "../EmployeeRegister/OtherInfo";
import Attachment from "../EmployeeRegister/Attachment";
import EmploymentDetails from "../EmployeeRegister/EmploymentDetails";
import { getHeaders } from "../../../utils/apiHelper";

class EditEmployeeListForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 1,
      userImage: "",
      userImageUrl: null,
      employeeId: "",
      employeeNameEng: "",
      employeeNameMyan: "",
      gender: "",
      dateOfBirth: "",
      actualDateOfBirth: "",
      emailAddress: "",
      nationality: "",
      personalPhone: "",
      careerSubLevel: "",
      officePhone: "",
      career_sublevel: [],
      region: "",
      address: "",
      joinDate: "",
      fatherName: "",
      martialStatus: "",
      motherName: "",
      parentCount: "",
      siblingCount: "",
      childCount: "",
      pInLawCount: "",
      qualificationList: null,
      selected_degree: null,
      selected_qualification: null,
      period: "",
      designation: "",
      organization: "",
      contactPerson: "",
      contactPhone: "",
      sameWithCtPerson: false,
      guarantor: "",
      guarantorPhone: "",
      guarantorNRC: "",
      guarantorNRC_NO: "",
      NrcFilterData: [],
      disConstatusList: [
        { value: 0, label: "False" },
        { value: 1, label: "True" },
      ],
      selected_bank: null,
      accountName: "",
      accountNumber: "",
      bankDataEdit: false,
      bankData: [],
      selected_bankRow_Id: 0,
      trainingCode: "",
      partTimeCode: "",
      customerCode: "",
      ThaPaYaAccount: "",
      SSCCardNo: "",
      attachmentUrl: "",
      employeeStatus: "",
      employeeDesignation: "",
      jobTitle: "",
      carrerLevel: "",
      employeeDetailBranch: "",
      employedDate: "",
      disConStatus: 2,
      disConDate: "",
      granDistrictCodeList: null,
      nrcList: null,
      selected_NRC_Id: null,
      selected_NRC_Category: null,
      selected_DistrictCode: null,
      nrc_number: "",
      selected_gran_NRC_Id: null,
      selected_gran_NRC_Category: null,
      selected_gran_DistrictCode: null,
      gran_nrc_number: "",
      location: "",
      addedDegreeData: [],
      addedQualitificationData: [],
      singleValue: { year: 2014, month: 11 },
      fromMonthYear: new Date(),
      toMonthYear: new Date(),
      workExpData: [],
      employeeStatusList: props.statusList || [],
      editMode: [null, null],
      last_promotion_date: "",
      bloodGroup: null,
      education: null,
    };
    this.hiddenFileInput = React.createRef();
    this.onStatusChange = this.onStatusChange.bind(this);
  }

  handleNext = (e) => {
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };

  async componentDidMount() { 
    await this.getEmployeeDetailsData();
  }

  async componentDidUpdate(prevProps) {
    const employeeChanged =
      prevProps.selectedEmployeeData !== this.props.selectedEmployeeData;
    const statusListChanged = prevProps.statusList !== this.props.statusList;

    if (statusListChanged) {
      await new Promise((resolve) =>
        this.setState(
          { employeeStatusList: this.props.statusList || [] },
          resolve
        )
      );
    }

    if (employeeChanged || statusListChanged) {
      await this.getEmployeeDetailsData();
    }
  }
  async getCareerSubLevelOptions() {
    await fetch(`${main_url}allowLevel/getCareerSubLevel`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then(async (res) => {
        if (res) {
          this.setState({ career_sublevel: await res });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  async getEmployeeDetailsData() {
    // confirmation/getOneDetail/:user_id
    await this.getCareerSubLevelOptions();
    const {
      selectedEmployeeData,
      level_options,
      nrcList,
      nrcCategoryList,
      granDistrictCodeList,
      districtCodeList,
      branchlist,
      bloodGroupsList,
      educationList,
    } = this.props;
    const { disConstatusList } = this.state;
    await fetch(
      `${main_url}confirmation/getOneDetail/${this.props.selectedEmployeeData.user_id}`,
      {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res.length > 0) {
          let CarrerSubLevelFilter = {};
          if (typeof res[0].career_sub_level == "number") {
            let filterCarrersubLevel =
              this.state.career_sublevel.filter(
                (v) => v.career_sub_level_id == res[0].career_sub_level
              ).length > 0
                ? this.state.career_sublevel.filter(
                    (v) => v.career_sub_level_id == res[0].career_sub_level
                  )[0].career_sub_level
                : "-";
            CarrerSubLevelFilter = filterCarrersubLevel;
          } else {
            let filterCarrersubLevel =
              this.state.career_sublevel.filter(
                (v) => v.career_sub_level == res[0].career_sub_level
              ).length > 0
                ? this.state.career_sublevel.filter(
                    (v) => v.career_sub_level == res[0].career_sub_level
                  )[0].career_sub_level
                : "-";
            CarrerSubLevelFilter = filterCarrersubLevel;
          }

          // *** Filter and fill NRC district code dropdown values with NRC sd code ***
          // Without this block of code, when employee is edited, NRC district code dropdown options will be empty and
          // user needs to select NRC sd code again to get NRC district code dropdown options.
          const selectedNrcId =
            nrcList && nrcList.find((c) => c.value == res[0].NRC_SD_code)
              ? nrcList.find((c) => c.value == res[0].NRC_SD_code)
              : null;
          if (
            selectedNrcId &&
            this.props.districtCodeList &&
            this.props.districtCodeList.length > 0
          ) {
            this.setState({
              NrcFilterData: this.props.districtCodeList.filter(
                (v) => v.sd_code == selectedNrcId.sd_code
              ),
            });
          }
          //__________________________________________________________________________

          this.setState({
            userImage: res[0].avatar,
            userImageUrl: res[0].avatar,
            employeeId: res[0].employment_id,
            employeeNameEng: res[0].fullname,
            employeeNameMyan: res[0].employee_name_myn,
            gender: res[0].gender,
            dateOfBirth: res[0].date_of_birth,
            actualDateOfBirth: res[0].actual_date_of_birth,
            emailAddress: res[0].email_address,
            bloodGroup: bloodGroupsList.find(bloodGroup => bloodGroup.value === res[0].blood_group),
            education: educationList.find(education => education.value === res[0].education),
            nationality: res[0].country,
            personalPhone: res[0].personal_phone,
            officePhone: res[0].office_phone,
            region: res[0].city,
            address: res[0].address,
            joinDate: res[0].joining_date,
            fatherName: res[0].father_name,
            martialStatus: res[0].maratial_status,
            motherName: res[0].mother_name,
            parentCount: res[0].parent_count,
            siblingCount: res[0].sibling_count,
            childCount: res[0].child_count,
            pInLawCount: res[0].parent_in_law_count,
            addedDegreeData: res[0].degree,
            addedQualitificationData: res[0].qualification,
            // careerSubLevel : res[0].career_sub_level,
            contactPerson: res[0].contact_person,
            contactPhone: res[0].contact_person_phone,
            sameWithCtPerson: res[0].same_with_contact_person,
            guarantor: res[0].gurantee_person,
            guarantorPhone: res[0].gurantee_person_phone,
            bankData: res[0].bank_info,
            trainingCode: res[0].training_code,
            partTimeCode: res[0].part_time_code,
            customerCode: res[0].customer_code,
            ThaPaYaAccount: res[0].thapyay_account,
            SSCCardNo: res[0].SSC_card_no,
            attachmentUrl: res[0].attachmentUrl,
            employeeStatus: this.state.employeeStatusList.find(
              (c) => c.value == res[0].employee_status
            ),
            employeeDesignation: this.props.designationList.find(
              (c) => c.value == res[0].designations_id
            ),
            jobTitle: res[0].job_title,
            // careerSubLevel : res[0].career_sub_level ? this.state.career_sublevel.filter(v=>v.career_sub_level_id == res[0].career_sub_level)[0].career_sub_level : '-',
            careerSubLevel: CarrerSubLevelFilter,
            carrerLevel:
              level_options &&
              level_options.find((c) => c.value == res[0].career_level_id)
                ? level_options.find((c) => c.value == res[0].career_level_id)
                : null,
            employeeDetailBranch:
              branchlist &&
              branchlist.find((c) => c.value == res[0].branch_name)
                ? branchlist.find((c) => c.value == res[0].branch_name)
                : null,
            employedDate: res[0].employ_date,
            disConStatus:
              res[0].discontinued_status == 1
                ? disConstatusList.find((c) => c.value == 1)
                : disConstatusList.find((c) => c.value == 0),
            disConDate: res[0].discontinued_date,
            selected_NRC_Id: selectedNrcId,
            selected_NRC_Category:
              nrcCategoryList && nrcCategoryList.find((c) => c.nrc_category_id == res[0].NRC_category)
                ? nrcCategoryList.find((c) => c.nrc_category_id == res[0].NRC_category)
                : null,
            selected_DistrictCode:
              districtCodeList &&
              districtCodeList.find((c) => c.value == res[0].NRC_District_code)
                ? districtCodeList.find(
                    (c) => c.value == res[0].NRC_District_code
                  )
                : null, ////
            nrc_number: res[0].NRC_no ? res[0].NRC_no : "",
            selected_gran_NRC_Id:
              nrcList &&
              nrcList.find(
                (c) => parseInt(c.value) == res[0].NRC_SD_code_guarantee
              )
                ? nrcList.find(
                    (c) => parseInt(c.value) == res[0].NRC_SD_code_guarantee
                  )
                : null,
            selected_gran_NRC_Category:
              nrcCategoryList && nrcCategoryList.find((c) => c.nrc_category_id == res[0].NRC_category_guarantee)
                ? nrcCategoryList.find((c) => c.nrc_category_id == res[0].NRC_category_guarantee)
                : null,
            selected_gran_DistrictCode:
              granDistrictCodeList &&
              granDistrictCodeList.find(
                (c) => c.id == res[0].NRC_District_code_guarantee
              )
                ? granDistrictCodeList.find(
                    (c) => c.id == res[0].NRC_District_code_guarantee
                  )
                : null,
            gran_nrc_number: res[0].NRC_no_guarantee
              ? res[0].NRC_no_guarantee
              : "",
            workExpData: res[0].work_experience,
            fullNRC: res[0].nrc,
            guaFullNRC: res[0].NRC_full_gurantee,
            last_promotion_date: res[0].last_promotion_date,
          });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  updateEmployee = () => {
    const {
      selected_NRC_Id,
      selected_NRC_Category,
      userImage,
      userImageUrl,
      employeeId,
      employeeNameEng,
      employeeNameMyan,
      dateOfBirth,
      actualDateOfBirth,
      emailAddress,
      gender,
      nationality,
      personalPhone,
      region,
      officePhone,
      selected_DistrictCode,
      nrc_number,
      selected_gran_NRC_Id,
      selected_gran_NRC_Category,
      disConDate,
      disConStatus,
      addedDegreeData,
      addedQualitificationData,
      workExpData,
      contactPerson,
      contactPhone,
      checked,
      guarantor,
      guarantorPhone,
      bankData,
      address,
      joinDate,
      martialStatus,
      fatherName,
      motherName,
      parentCount,
      siblingCount,
      childCount,
      pInLawCount,
      trainingCode,
      partTimeCode,
      customerCode,
      ThaPaYaAccount,
      SSCCardNo,
      attachmentUrl,
      employeeStatus,
      employeeDesignation,
      jobTitle,
      carrerLevel,
      careerSubLevel,
      employeeDetailBranch,
      employedDate,
      selected_gran_DistrictCode,
      gran_nrc_number,
      last_promotion_date,
      bloodGroup,
      education,
    } = this.state;
    if (!selected_NRC_Category) return toast.error("NRC category cannot be empty!");
    let fullNRCNO = `${selected_NRC_Id ? selected_NRC_Id.label : ""}/ ${
      selected_DistrictCode ? selected_DistrictCode.label : ""
    }(${selected_NRC_Category.nrc_category_code}) ${nrc_number}`;
    let guarantorNRC = `${
      selected_gran_NRC_Id ? selected_gran_NRC_Id.label : ""
    }/ ${
      selected_gran_DistrictCode ? selected_gran_DistrictCode.label : ""
    }(${selected_gran_NRC_Category ? selected_gran_NRC_Category.nrc_category_code : " "})${gran_nrc_number}`;

    // * Validate Personal Phone *
    const personalPhoneInvalidMessage = validatePhoneNumber(
      personalPhone,
      "Personal Phone"
    );
    if (personalPhoneInvalidMessage) {
      return toast.error(personalPhoneInvalidMessage);
    }

    // * Validate Office Phone *
    const officePhoneInvalidMessage = validatePhoneNumber(
      officePhone,
      "Office Phone"
    );
    if (officePhoneInvalidMessage) {
      return toast.error(officePhoneInvalidMessage);
    }

    // * Validate Contact Phone *
    const contactPhoneInvalidMessage = validatePhoneNumber(
      contactPhone,
      "Contact Phone"
    );
    if (contactPhoneInvalidMessage) {
      return toast.error(contactPhoneInvalidMessage);
    }

    const isEmailValid = validateEmailAddress(emailAddress);
    if (!isEmailValid && emailAddress) return toast.error("Invalid Email Address");

    var data = {
      employeeId: employeeId,
      employeeNameEng: employeeNameEng,
      employeeNameMyan: employeeNameMyan,
      fullNRCNO: fullNRCNO,
      dateOfBirth: dateOfBirth,
      actualDateOfBirth: actualDateOfBirth,
      emailAddress: emailAddress,
      gender: gender,
      nationality: nationality,
      personalPhone: personalPhone,
      region: region,
      officePhone: officePhone,
      address: address,
      joinDate: joinDate,
      martialStatus: martialStatus,
      fatherName: fatherName,
      motherName: motherName,
      parentCount: parentCount,
      siblingCount: siblingCount,
      childCount: childCount,
      pInLawCount: pInLawCount,
      addedDegreeData: addedDegreeData,
      contactPerson: contactPerson,
      contactPhone: contactPhone,
      checked: checked,
      guarantor: guarantor,
      guarantorNRC: guarantorNRC,
      guarantorPhone: guarantorPhone,
      trainingCode: trainingCode,
      partTimeCode: partTimeCode,
      customerCode: customerCode,
      ThaPaYaAccount: ThaPaYaAccount,
      SSCCardNo: SSCCardNo,
      attachmentUrl: attachmentUrl,
      employeeStatus: employeeStatus ? employeeStatus.value : null,
      employeeDesignation: employeeDesignation
        ? employeeDesignation.value
        : null,
      jobTitle: jobTitle,
      careerSubLevel: careerSubLevel ? careerSubLevel : null,
      carrerLevel: carrerLevel ? carrerLevel.value : null,
      employeeDetailBranch: employeeDetailBranch
        ? employeeDetailBranch.value
        : null,
      employedDate: employedDate,
      disConStatus: disConStatus ? disConStatus.value : null,
      disConDate: disConDate,
      user_id: getCookieData("user_info").user_id,
      NRC_SD_code: selected_NRC_Id ? selected_NRC_Id.value : null,
      NRC_category: selected_NRC_Category ? selected_NRC_Category.nrc_category_id : null,
      NRC_District_code: selected_DistrictCode
        ? selected_DistrictCode.value
        : null,
      NRC_no: nrc_number,
      NRC_SD_code_gurantee: selected_gran_NRC_Id
        ? selected_gran_NRC_Id.value
        : null,
      NRC_category_guarantee: selected_gran_NRC_Category ? selected_gran_NRC_Category.nrc_category_id : null,
      NRC_District_code_gurantee: selected_gran_DistrictCode
        ? selected_gran_DistrictCode.value
        : null,
      NRC_no_gurantee: gran_nrc_number,
      same_with_CT_person: this.state.sameWithCtPerson ? 1 : 0,
      bloodGroup: bloodGroup?.blood_group_id,
      education: education?.education_id,
    };
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data));
    formdata.append("bank", JSON.stringify(bankData));
    formdata.append("work_experience", JSON.stringify(workExpData));
    formdata.append("qualification", JSON.stringify(addedQualitificationData));
    formdata.append("degree", JSON.stringify(addedDegreeData));
    formdata.append("uploadProfile", userImageUrl);
    let status = 0;
    fetch(
      `${main_url}employee/editEmployee/${this.props.selectedEmployeeData.user_id}`,
      {
        method: "POST",
        headers: getHeaders(),
        body: formdata,
      }
    )
      .then((res) => {
        status = res.status;
        return res.text();
      })
      .then((text) => {
        if (status === 200) {
          toast.success(text);

          window.location.reload();
        } else toast.error(text);
        window.location.replace("/employee_list");
      });
  };

  handleClick = (event) => {
    event.preventDefault();
    this.hiddenFileInput.current.click();
  };

  handleChange = (event) => {
    event.preventDefault();
    const file = event.target.files;
    const fileUploaded = file[0];

    this.setState({
      userImage: window.URL.createObjectURL(file[0]),
      userImageUrl: fileUploaded,
    });
  };

  handleAttachmentChange = (event) => {
    this.setState({
      attachmentUrl: event.target.value,
    });
  };

  handleInputChange = (e) => {
    if (e.target.name === "employeeId") {
      this.setState({
        employeeId: e.target.value,
      });
    } else if (e.target.name === "employeeNameEng") {
      this.setState({
        employeeNameEng: e.target.value.toUpperCase(),
      });
    } else if (e.target.name === "employeeNameMyan") {
      this.setState({
        employeeNameMyan: e.target.value,
      });
    } else if (e.target.name === "dateOfBirth") {
      if (this.state.nrc_number.length != 6) {
        toast.error("NRC number should be 6 digits!");
      } else {
        this.setState({
          dateOfBirth: e.target.value,
        });
      }
    } else if (e.target.name === "actualDateOfBirth") {
      this.setState({
        actualDateOfBirth: e.target.value,
      });
    } else if (e.target.name === "emailAddress") {
      this.setState({
        emailAddress: e.target.value,
      });
    } else if (e.target.name === "nationality") {
      this.setState({
        nationality: e.target.value,
      });
    } else if (e.target.name === "personalPhone") {
      const currVal = this.state.personalPhone;
      let newVal = e.target.value;
      const isValid = validatePhoneNumberInput(currVal, newVal);
      if (!isValid) return;
      if (newVal.length === 0) newVal = "9";
      if (newVal[0] !== "9") newVal = "9" + newVal;
      this.setState({
        personalPhone: newVal,
      });
    } else if (e.target.name === "officePhone") {
      const currVal = this.state.officePhone;
      let newVal = e.target.value;
      const isValid = validatePhoneNumberInput(currVal, newVal);
      if (!isValid) return;
      if (newVal.length === 0) newVal = "9";
      if (newVal[0] !== "9") newVal = "9" + newVal;
      this.setState({
        officePhone: newVal,
      });
    }
     else if (e.target.name === "region") {
      this.setState({
        region: e.target.value,
      });
    } else if (e.target.name === "address") {
      this.setState({
        address: e.target.value,
      });
    } else if (e.target.name === "joinDate") {
      this.setState({
        joinDate: e.target.value,
      });
    } else if (
      e.target.name === "nrc_number" &&
      this.state.selected_NRC_Id &&
      this.state.selected_DistrictCode
    ) {
      if (e.target.value.length < 7) {
        this.setState({
          nrc_number: e.target.value,
          fullNRC:
            this.state.selected_NRC_Id.label +
            "/" +
            this.state.selected_DistrictCode.label +
            `(${this.state.selected_NRC_Category ? this.state.selected_NRC_Category.nrc_category_code : " "})` +
            e.target.value,
        });
      }
    } else if (e.target.name === "nrc_number" && !this.state.selected_NRC_Id) {
      toast.error("Please Choose Sd code first!");
    } else if (
      e.target.name === "nrc_number" &&
      !this.state.selected_DistrictCode
    ) {
      toast.error("Please Choose District code first!");
    }
  };

  handleBloodGroupChange = (e) => {
    this.setState({
      bloodGroup: e,
    });
  };

  handleEducationChange = (e) => {
    this.setState({
      education: e,
    });
  };

  handleBankDetailInputChange = (e) => {
    if (e.target.name === "accountName") {
      this.setState({
        accountName: e.target.value.toUpperCase(),
      });
    } else if (e.target.name === "accountNumber") {
      this.setState({
        accountNumber: e.target.value,
      });
    }
  };
  handleOtherInfoInputChange = (e) => {
    if (e.target.name === "trainingCode") {
      this.setState({
        trainingCode: e.target.value,
      });
    } else if (e.target.name === "partTimeCode") {
      this.setState({
        partTimeCode: e.target.value,
      });
    } else if (e.target.name === "customerCode") {
      this.setState({
        customerCode: e.target.value,
      });
    } else if (e.target.name === "ThaPaYaAccount") {
      this.setState({
        ThaPaYaAccount: e.target.value,
      });
    } else if (e.target.name === "SSCCardNo") {
      this.setState({
        SSCCardNo: e.target.value,
      });
    }
  };
  handleEmploymentDetailInputChange = (e) => {
    if (e.target.name === "jobTitle") {
      this.setState({
        jobTitle: e.target.value,
      });
    } else if (e.target.name === "employedDate") {
      this.setState({
        employedDate: e.target.value,
      });
    } else if (e.target.name === "disConDate") {
      this.setState({
        disConDate: e.target.value,
      });
    }
  };

  // nrcErr = e => {
  //     if(this.state.nrc_number.length < 6) {
  //         toast.error('NRC number should be 6 digit!')
  //     }
  // }

  onGenderChange = (e) => {
    this.setState({
      gender: e.target.value,
    });
  };
  onStatusChange = (option) => {
    this.setState({
      martialStatus: option ? option.value : "",
    });
  };
  handleSelectedDegree = (event) => {
    if (event !== null)
      this.setState({
        selected_degree: event,
      });
  };
  handleSelectedBank = (event) => {
    if (event !== null)
      this.setState({
        selected_bank: event,
      });
  };
  handleSelectedBranch = (event) => {
    if (event !== null)
      this.setState({
        employeeDetailBranch: event,
      });
  };
  handleSelectedDistrictCode = (event) => {
    if (event !== null && this.state.selected_NRC_Id)
      this.setState({
        selected_DistrictCode: event,
        fullNRC:
          (this.state.selected_NRC_Id === null
            ? ""
            : this.state.selected_NRC_Id.label) +
          "/" +
          event.label +
          `(${this.state.selected_NRC_Category ? this.state.selected_NRC_Category.nrc_category_code : " "})/` +
          (this.state.nrc_number ? this.state.nrc_number : ""),
      });
    else if (!this.state.selected_NRC_Id)
      return toast.error("Please choose sd code first");
  };

  handleSelectedNRCId = (event) => {
    if (event !== null) {
      let filterData = this.props.districtCodeList.filter(
        (v) => v.sd_code == event.sd_code
      );
      this.setState({
        selected_NRC_Id: event,
        NrcFilterData: filterData,
        fullNRC:
          event.label +
          "/" +
          (this.state.selected_DistrictCode === null
            ? ""
            : this.state.selected_DistrictCode.label) +
          `(${this.state.selected_NRC_Category ? this.state.selected_NRC_Category.nrc_category_code : " "})/` +
          (this.state.nrc_number ? this.state.nrc_number : ""),
      });
      // this.props.getNRC_DistrictCode(event.label)
    }
  };

  handleSelectedNRCCategory = (event) => {
    if (event !== null) {
      this.setState({
        selected_NRC_Category: event,
        fullNRC: 
        this.state.selected_NRC_Id.label +
          "/" +
          (this.state.selected_DistrictCode === null
            ? ""
            : this.state.selected_DistrictCode.label) +
          `(${event.nrc_category_code})/` +
          (this.state.nrc_number ? this.state.nrc_number : ""),
      });
    }
  };

  handleGranDistrictCode = (event) => {
    if (event !== null && this.state.selected_gran_NRC_Id) {
      this.setState({
        selected_gran_DistrictCode: event,
        guaFullNRC:
          (this.state.selected_gran_NRC_Id === null
            ? ""
            : this.state.selected_gran_NRC_Id.label) +
          event.label +
          `(${this.state.selected_gran_NRC_Category ? this.state.selected_gran_NRC_Category.nrc_category_code : " "})/` +
          (this.state.gran_nrc_number ? this.state.gran_nrc_number : ""),
      });
    } else if (!this.state.selected_gran_NRC_Id)
      return toast.error("Please choose sd code first");
  };

  handleNRC_Id = (event) => {
    if (event !== null) {
      this.setState({
        selected_gran_NRC_Id: event,
        guaFullNRC:
          event.label +
          (this.state.selected_gran_DistrictCode === null
            ? ""
            : this.state.selected_gran_DistrictCode.label) +
          `(${this.state.selected_gran_NRC_Category ? this.state.selected_gran_NRC_Category.nrc_category_code : " "})/` +
          (this.state.gran_nrc_number ? this.state.gran_nrc_number : ""),
      });
      // this.props.getGran_NRC_DistrictCode(event.label)
    }
  };
  handleGranSelectedNRCCategory = (event) => {
    if (event !== null) {
      this.setState({
        selected_gran_NRC_Category: event,
        guaFullNRC: 
        this.state.selected_gran_NRC_Id ? 
          this.state.selected_gran_NRC_Id.label +
            "/" +
            (this.state.selected_gran_DistrictCode === null
              ? ""
              : this.state.selected_gran_DistrictCode.label) +
            `(${event.nrc_category_code})/` +
            (this.state.gran_nrc_number ? this.state.gran_nrc_number : "")
          : "",
      });
    }
  };
  handleSelectedQualification = (event) => {
    if (event !== null)
      this.setState({
        selected_qualification: event,
      });
  };

  handleProfileSave = (e) => {
    e.preventDefault();
    const { nrc_number, personalPhone, officePhone, emailAddress } = this.state;
    if (nrc_number.length < 6) {
      return toast.error("NRC number should be 6 digits!");
    }
    const personalPhoneInvalidMessage = validatePhoneNumber(
      personalPhone,
      "Personal Phone"
    );
    if (personalPhoneInvalidMessage) {
      return toast.error(personalPhoneInvalidMessage);
    }
    const officePhoneInvalidMessage = validatePhoneNumber(
      officePhone,
      "Office Phone"
    );
    if (officePhoneInvalidMessage) {
      return toast.error(officePhoneInvalidMessage);
    }
    const isEmailValid = validateEmailAddress(emailAddress);
    if (!isEmailValid && emailAddress)
      return toast.error("Invalid Email Address");
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };

  handlePersonalDetailInputChange = (e) => {
    if (e.target.name === "fatherName") {
      this.setState({
        fatherName: e.target.value,
      });
    } else if (e.target.name === "motherName") {
      this.setState({
        motherName: e.target.value,
      });
    } else if (e.target.name === "parentCount") {
      if (e.target.value < 0 || e.target.value > 4) return;
      this.setState({
        parentCount: e.target.value,
      });
    } else if (e.target.name === "siblingCount") {
      this.setState({
        siblingCount: e.target.value,
      });
    } else if (e.target.name === "childCount") {
      this.setState({
        childCount: e.target.value,
      });
    } else if (e.target.name === "pInLawCount") {
      this.setState({
        pInLawCount: e.target.value,
      });
    }
  };

  handleContactDetailInputChange = (e) => {
    if (e.target.name === "contactPerson") {
      this.setState({
        contactPerson: e.target.value,
      });
    } else if (e.target.name === "contactPhone") {
      const currVal = this.state.contactPhone;
      let newVal = e.target.value;
      const isValid = validatePhoneNumberInput(currVal, newVal);
      if (!isValid) return;
      if (newVal.length === 0) newVal = "9";
      if (newVal && newVal.startsWith("09")) newVal = newVal.slice(1);
      if (newVal[0] !== "9") newVal = "9" + newVal;
      this.setState({
        contactPhone: newVal,
      });
    } else if (e.target.name === "guarantor") {
      this.setState({
        guarantor: e.target.value,
      });
    } else if (e.target.name === "guarantorPhone") {
      const currVal = this.state.guarantorPhone;
      let newVal = e.target.value;
      const isValid = validatePhoneNumberInput(currVal, newVal);
      if (!isValid) return;
      if (newVal.length === 0) newVal = "9";
      if (newVal && newVal.startsWith("09")) newVal = newVal.slice(1);
      if (newVal[0] !== "9") newVal = "9" + newVal;
      this.setState({
        guarantorPhone: newVal,
      });
    } else if (
      e.target.name === "gran_nrc_no" &&
      this.state.selected_gran_NRC_Id &&
      this.state.selected_gran_DistrictCode
    ) {
      if (e.target.value.length < 7) {
        this.setState({
          gran_nrc_number: e.target.value,
          guaFullNRC:
            this.state.selected_gran_NRC_Id.label +
            "/" +
            this.state.selected_gran_DistrictCode.label +
            `(${this.state.selected_gran_NRC_Category ? this.state.selected_gran_NRC_Category.nrc_category_code : " "})` +
            e.target.value,
        });
      }
    } else if (
      e.target.name === "gran_nrc_no" &&
      !this.state.selected_gran_NRC_Id
    ) {
      toast.error("Please Choose Sd code first!");
    } else if (
      e.target.name === "gran_nrc_no" &&
      !this.state.selected_gran_DistrictCode
    ) {
      toast.error("Please Choose District code first!");
    }
  };

  handlePersonalDetail = (e) => {
    e.preventDefault();
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };
  handleEducationDetails = (e) => {
    e.preventDefault();
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };

  handleContactDetails = (e) => {
    e.preventDefault();
    const { gran_nrc_number, contactPhone, guarantorPhone } = this.state;

    // * Validate Contact Phone
    const contactPhoneInvalidMessage = validatePhoneNumber(
      contactPhone,
      "Contact Phone"
    );
    if (contactPhoneInvalidMessage) {
      return toast.error(contactPhoneInvalidMessage);
    }

    // Since Guarantor Phone is optional field, we validate only if it exists.
    if (guarantorPhone && guarantorPhone !== "9") {
      // * Validate Guarantor Phone
      const guarantorPhoneInvalidMessage = validatePhoneNumber(
        guarantorPhone,
        "Guarantor Phone"
      );
      if (guarantorPhoneInvalidMessage) {
        return toast.error(guarantorPhoneInvalidMessage);
      }
    }
    // If it's just "9", we remove this.
    if (guarantorPhone === "9") {
      this.setState({
        guarantorPhone: "",
      });
    }

    if (gran_nrc_number.length < 6) {
      this.setState({
        tabIndex: this.state.tabIndex + 1,
      });
    } else {
      this.setState({
        tabIndex: this.state.tabIndex + 1,
      });
    }
  };
  handleBankAccountDetails = (e) => {
    e.preventDefault();
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };
  handleOtherInfo = (e) => {
    e.preventDefault();
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };

  handleAttachment = (e) => {
    e.preventDefault();
    this.setState({
      tabIndex: this.state.tabIndex + 1,
    });
  };
  handleEmploymentDetail = (e) => {
    e.preventDefault();
    this.updateEmployee();
    this.setState({
      tabIndex: 1,
    });
  };

  handleWorkExpChange = () => {
    this.setState({
      workExpChecked: !this.state.workExpChecked,
    });
  };
  handleSameWithCtPersonChange = () => {
    this.setState({
      sameWithCtPerson: !this.state.sameWithCtPerson,
    });
  };

  handleEditBankData = (data) => {
    this.setState({
      accountName: data.account_name.toUpperCase(),
      accountNumber: data.account_no,
      bankDataEdit: true,
      selected_bank: this.props.bankList.find((c) => c.value === data.bank_id),
      selected_bankRow_Id: data.bank_id,
    });
  };

  handleAdd_UpdateBankData = (e) => {
    e.preventDefault();
    const {
      accountName,
      accountNumber,
      selected_bank,
      bankDataEdit,
      bankData,
      employeeNameEng,
      selected_bankRow_Id,
    } = this.state;

    if (bankDataEdit) {
      // ("Update")
      const newData = {
        bank_id: selected_bank.value,
        account_no: accountNumber,
        bank_name: selected_bank.label,
        account_name: accountName.toUpperCase(),
      };
      for (var i = 0; i < bankData.length; i++) {
        if (bankData[i].bank_id == selected_bankRow_Id) {
          bankData.splice(i, 1);
        }
      }
      this.setState({
        bankData: bankData.concat(newData),
        bankDataEdit: false,
        accountName: "",
        selected_bank: null,
        accountNumber: "",
      });
    } else {
      if (selected_bank == null) {
        this.setState({ tabIndex: 6 });
      } else {
        const newData = {
          id: bankData.length + 1,
          account_no: accountNumber,
          bank_name: selected_bank.label,
          account_name: accountName.toUpperCase(),
        };
        this.setState({
          bankData: bankData.concat(newData),
          accountName: "",
          selected_bank: null,
          accountNumber: "",
        });
      }
    }
  };

  handleDeleteBankData = (data) => {
    for (var i = 0; i < this.state.bankData.length; i++) {
      if (this.state.bankData[i].id == data.id) {
        this.state.bankData.splice(i, 1);
      }
    }
    this.setState({
      bankData: this.state.bankData,
      bankDataEdit: false,
      accountName: "",
      selected_bank: null,
      accountNumber: "",
    });
  };
  handleSameWithCtPersonChange = () => {
    this.setState(
      {
        sameWithCtPerson: !this.state.sameWithCtPerson,
      },
      () => {
        if (this.state.sameWithCtPerson) {
          this.setState({
            guarantor: this.state.contactPerson,
            guarantorPhone: this.state.contactPhone,
          });
        } else {
          this.setState({
            guarantor: "",
            guarantorPhone: "",
          });
        }
      }
    );
  };

  handleAddDegreeData = () => {
    const { selected_degree, addedDegreeData, editMode } = this.state;
    if (selected_degree) {
      const deg = {
        id: selected_degree.id,
        name: selected_degree.degree,
      };
      if (editMode[0] == "degree") {
        const newObj = [...addedDegreeData];
        newObj.splice(editMode[1], 1, deg);
        this.setState({
          addedDegreeData: newObj,
          editMode: [null, null],
          selected_degree: null,
        });
      } else {
        if (addedDegreeData.length > 0) {
          this.setState({
            addedDegreeData:
              addedDegreeData.filter((c) => c.id === selected_degree.id)
                .length > 0
                ? addedDegreeData
                : addedDegreeData.concat(deg),
            selected_degree: null,
          });
        } else
          this.setState({
            addedDegreeData: addedDegreeData.concat(deg),
            selected_degree: null,
          });
      }
    } else toast.error("Please Choose degree at first!");
  };

  handleUpdateDegreeData = (data, id) => {
    this.setState({
      selected_degree: {
        label: data.name,
        value: data.id,
        degree: data.name,
        ...data,
      },
      editMode: ["degree", id],
    });
  };

  handleAddQualification = () => {
    const { selected_qualification, addedQualitificationData, editMode } =
      this.state;
    if (selected_qualification) {
      if (editMode[0] == "qualification") {
        const obj = {
          id: editMode[1],
          name: selected_qualification,
        };
        const newObj = [...addedQualitificationData];
        newObj.splice(editMode[1], 1, obj);
        this.setState({
          addedQualitificationData: newObj,
          editMode: [null, null],
          selected_qualification: "",
        });
      } else {
        let data = {
          id: addedQualitificationData.length + 1,
          name: selected_qualification,
        };
        this.setState({
          addedQualitificationData: addedQualitificationData.concat(data),
          selected_qualification: "",
        });
      }
    } else toast.error("Please Add Qualifications at first!");
  };

  handleUpdateQualification = (data, id) => {
    this.setState({
      selected_qualification: data.name,
      editMode: ["qualification", id],
    });
  };

  handleSelectedDesignation = (event) => {
    if (event !== null)
      this.setState({
        employeeDesignation: event,
      });
  };

  handleSelectedDisConStus = (event) => {
    if (event !== null)
      this.setState({
        disConStatus: event,
      });
  };

  handleSelectedEmpStatus = (event) => {
    if (event !== null)
      this.setState({
        employeeStatus: event,
      });
  };

  handleLevelSelectorChange = (event) => {
    if (event !== null)
      this.setState({
        carrerLevel: event,
      });
  };

  handleAddWorkExp = (e) => {
    e.preventDefault();
    const {
      workExpData,
      period,
      location,
      designation,
      fromMonthYear,
      toMonthYear,
      organization,
      editMode,
    } = this.state;
    if (editMode[0] == "work") {
      const obj = {
        period,
        location,
        designation,
        organization,
        from_year: fromMonthYear,
        to_year: toMonthYear,
      };
      const newObj = [...workExpData];
      newObj.splice(editMode[1], 1, obj);
      this.setState({
        workExpData: newObj,
        editMode: [null, null],
        period: "",
        location: "",
        designation: "",
        organization: "",
      });
    } else {
      const data = {
        period,
        location,
        designation,
        organization,
        from_year: fromMonthYear,
        to_year: toMonthYear,
      };

      this.setState({
        workExpData: workExpData.concat(data),
        period: "",
        location: "",
        designation: "",
        organization: "",
      });
    }
  };

  handleUpdateWorkExp = (data, id) => {
    this.setState({
      period: data.period,
      location: data.location,
      designation: data.designation,
      organization: data.organization,
      from_year: data.from_year,
      to_year: data.to_year,
      editMode: ["work", id],
    });
  };

  handlePreviousClick = () => {
    this.setState({ tabIndex: this.state.tabIndex - 1 });
  };

  handleEduactionInputChange = (e) => {
    e.preventDefault();
    if (e.target.name === "period") {
      this.setState({
        period: e.target.value,
      });
    } else if (e.target.name === "location") {
      this.setState({
        location: e.target.value,
      });
    } else if (e.target.name === "qualification") {
      this.setState({
        selected_qualification: e.target.value,
      });
    } else if (e.target.name === "designation") {
      this.setState({
        designation: e.target.value,
      });
    } else if (e.target.name === "organization") {
      this.setState({
        organization: e.target.value,
      });
    }
  };

  handleToMonthYear = (e) => {
    this.setState(
      {
        toMonthYear: e,
      },
      async () => {
        this.setState({
          period: await calculationWorkingExp(e, this.state.fromMonthYear),
        });
      }
    );
  };

  handleFromMonthYear = (e) => {
    this.setState(
      {
        fromMonthYear: e,
      },
      async () => {
        this.setState({
          period: await calculationWorkingExp(this.state.toMonthYear, e),
        });
      }
    );
  };

  handleRemoveWorkExp = (id) => {
    const { workExpData } = this.state;
    const newObj = [...workExpData];
    newObj.splice(id, 1);
    this.setState({
      workExpData: newObj,
    });
  };

  handleRemoveDegreeData = (id) => {
    const { addedDegreeData } = this.state;
    const newObj = [...addedDegreeData];
    newObj.splice(id, 1);
    this.setState({
      addedDegreeData: newObj,
    });
  };

  handleRemoveQualification = (id) => {
    const { addedQualitificationData } = this.state;
    const newObj = [...addedQualitificationData];
    newObj.splice(id, 1);
    this.setState({
      addedQualitificationData: newObj,
    });
  };

  cancelEdit = () => {
    this.setState({
      bankDataEdit: false,
      accountName: "",
      selected_bank: null,
      accountNumber: "",
    });
  };

  clearProfileData = () => {
    this.setState({
      userImage: null,
      userImageUrl: null,
      employeeId: "",
      employeeNameEng: "",
      employeeNameMyan: "",
      gender: "",
      dateOfBirth: "",
      actualDateOfBirth: "",
      emailAddress: "",
      nationality: "",
      personalPhone: "",
      officePhone: "",
      region: "",
      address: "",
      joinDate: "",
      workExpChecked: false,
      bloodGroup: null,
    });
  };

  render() {
    const {
      tabIndex,
      userImage,
      userImageUrl,
      nrc_number,
      period,
      fullNRC,
      designation,
      workExpChecked,
      organization,
      sameWithCtPerson,
      selected_bank,
      trainingCode,
      partTimeCode,
      customerCode,
      ThaPaYaAccount,
      SSCCardNo,
      fatherName,
      qualificationList,
      selected_qualification,
      selected_degree,
      motherName,
      guarantor,
      guarantorPhone,
      attachmentUrl,
      selected_gran_NRC_Id,
      selected_gran_NRC_Category,
      employeeStatusList,
      disConstatusList,
      selected_gran_DistrictCode,
      guaFullNRC,
      gran_nrc_number,
      parentCount,
      siblingCount,
      childCount,
      pInLawCount,
      martialStatus,
      officePhone,
      region,
      address,
      joinDate,
      accountName,
      accountNumber,
      employeeStatus,
      employeeDesignation,
      jobTitle,
      carrerLevel,
      careerSubLevel,
      employeeDetailBranch,
      employedDate,
      disConStatus,
      disConDate,
      employeeId,
      employeeNameEng,
      nationality,
      NrcFilterData,
      last_promotion_date,
      personalPhone,
      employeeNameMyan,
      gender,
      addedDegreeData,
      addedQualitificationData,
      workExpData,
      fromMonthYear,
      toMonthYear,
      location,
      dateOfBirth,
      actualDateOfBirth,
      emailAddress,
      contactPerson,
      contactPhone,
      bankData,
      bankDataEdit,
      selected_DistrictCode,
      selected_NRC_Id,
      selected_NRC_Category,
      bloodGroup,
      education,
    } = this.state;
    const {
      selectedEmployeeData,
      level_options,
      editForm,
      BackToTable,
      viewForm,
      bankList,
      degreeList,
      nrcList,
      nrcCategoryList,
      districtCodeList,
      designationList,
      branchlist,
      granDistrictCodeList,
      bloodGroupsList,
      educationList,
    } = this.props;
    return (
      <div className=" border-bottom white-bg dashboard-header">
        <div
          className="tabBar col-lg-12 col-md-12 col-sm-12 "
          style={{
            display: "flex",
            paddingLeft: 0,
            paddingRight: 0,
            flexDirection: "row",
            paddingTop: 20,
            fontSize: 13,
            minWidth: 300,
            overflowX: "auto",
            alignItems: "center",
          }}
        >
          <div
            className="col-lg-2 col-md-2 "
            onClick={() => this.setState({ tabIndex: 1 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 1 ? 5 : 0,
              fontWeight: tabIndex === 1 ? "bold" : "normal",
              minHeight: tabIndex === 1 ? 35 : 30,
              background: `${tabIndex === 1 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 1 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Employee Profile
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 2 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 2 ? 5 : 0,
              fontWeight: tabIndex === 2 ? "bold" : "normal",
              minHeight: tabIndex === 2 ? 35 : 30,
              background: `${tabIndex === 2 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 2 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Personal Detail
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 3 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 3 ? 5 : 0,
              fontWeight: tabIndex === 3 ? "bold" : "normal",
              minHeight: tabIndex === 3 ? 35 : 30,
              background: `${tabIndex === 3 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 3 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Education Details
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 4 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 4 ? 5 : 0,
              fontWeight: tabIndex === 4 ? "bold" : "normal",
              minHeight: tabIndex === 4 ? 35 : 30,
              background: `${tabIndex === 4 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 4 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Contact Details
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 5 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              minWidth: 150,
              cursor: "pointer",
              marginBottom: tabIndex === 5 ? 5 : 0,
              fontWeight: tabIndex === 5 ? "bold" : "normal",
              minHeight: tabIndex === 5 ? 35 : 30,
              background: `${tabIndex === 5 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 5 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Bank Account Details
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 6 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 6 ? 5 : 0,
              fontWeight: tabIndex === 6 ? "bold" : "normal",
              minHeight: tabIndex === 6 ? 35 : 30,
              background: `${tabIndex === 6 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 6 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Other Information
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 7 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              cursor: "pointer",
              marginBottom: tabIndex === 7 ? 5 : 0,
              fontWeight: tabIndex === 7 ? "bold" : "normal",
              minHeight: tabIndex === 7 ? 35 : 30,
              background: `${tabIndex === 7 ? "#fff" : "#337ab7"}`,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 7 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Attachment
          </div>
          <div
            className="col-lg-2 col-md-2"
            onClick={() => this.setState({ tabIndex: 8 })}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
              minWidth: 130,
              cursor: "pointer",
              marginBottom: tabIndex === 8 ? 5 : 0,
              fontWeight: tabIndex === 8 ? "bold" : "normal",
              minHeight: tabIndex === 8 ? 35 : 30,
              background: `${tabIndex === 8 ? "#fff" : "#337ab7"}`,
              minWidth: 150,
              paddingLeft: 10,
              paddingRight: 10,
              color: tabIndex === 8 ? "black" : "white",
              border: "1px solid lightgrey",
              borderBottom: "none",
              justifyContent: "center",
            }}
          >
            Employment Details
          </div>
        </div>
        {tabIndex === 1 ? (
          <EmployeeProfile
            editForm={editForm}
            viewForm={viewForm}
            onCancelClick={BackToTable}
            userImage={userImage}
            handleClick={this.handleClick}
            hiddenFileInput={this.hiddenFileInput}
            handleChange={this.handleChange}
            employeeNameEng={employeeNameEng}
            employeeId={employeeId}
            handleInputChange={this.handleInputChange}
            employeeNameMyan={employeeNameMyan}
            gender={gender}
            onGenderChange={this.onGenderChange}
            dateOfBirth={dateOfBirth}
            actualDateOfBirth={actualDateOfBirth}
            emailAddress={emailAddress}
            nationality={nationality}
            personalPhone={personalPhone}
            officePhone={officePhone}
            region={region}
            address={address}
            joinDate={joinDate}
            handleProfileSave={this.handleProfileSave}
            clearProfileData={this.clearProfileData}
            handleSelectedDistrictCode={this.handleSelectedDistrictCode}
            handleSelectedNRCId={this.handleSelectedNRCId}
            handleSelectedNRCCategory={this.handleSelectedNRCCategory}
            NrcFilterData={NrcFilterData}
            selected_DistrictCode={selected_DistrictCode}
            selected_NRC_Id={selected_NRC_Id}
            selected_NRC_Category={selected_NRC_Category}
            districtCodeList={
              selected_NRC_Id
                ? districtCodeList.filter(
                    (c) => c.sd_code == selected_NRC_Id.sd_code
                  )
                : districtCodeList
            }
            nrcList={nrcList}
            nrcCategoryList={nrcCategoryList}
            fullNRC={fullNRC}
            nrc_number={nrc_number}
            handleBloodGroupChange={this.handleBloodGroupChange}
            bloodGroupsList={bloodGroupsList}
            bloodGroup={bloodGroup}
            handleEducationChange={this.handleEducationChange}
            educationList={educationList}
            education={education}
          />
        ) : tabIndex === 2 ? (
          <PersonalDetail
            editForm={editForm}
            viewForm={viewForm}
            fatherName={fatherName}
            motherName={motherName}
            handlePersonalDetailInputChange={
              this.handlePersonalDetailInputChange
            }
            onStatusChange={this.onStatusChange}
            martialStatus={martialStatus}
            parentCount={parentCount}
            siblingCount={siblingCount}
            childCount={childCount}
            pInLawCount={pInLawCount}
            handlePersonalDetail={this.handlePersonalDetail}
            handlePreviousClick={this.handlePreviousClick}
            onCancelClick={BackToTable}
          />
        ) : tabIndex === 3 ? (
          <EducationDetails
            editForm={editForm}
            viewForm={viewForm}
            handleEducationDetails={this.handleEducationDetails}
            handleSelectedDegree={this.handleSelectedDegree}
            handleSelectedQualification={this.handleSelectedQualification}
            degreeList={degreeList}
            selected_degree={selected_degree}
            qualificationList={qualificationList}
            selected_qualification={selected_qualification}
            handleWorkExpChange={this.handleWorkExpChange}
            checked={workExpChecked}
            handleEduactionInputChange={this.handleEduactionInputChange}
            period={period}
            designation={designation}
            organization={organization}
            onCancelClick={BackToTable}
            location={location}
            handleAddDegreeData={this.handleAddDegreeData}
            addedDegreeData={addedDegreeData}
            addedQualitificationData={addedQualitificationData}
            workExpData={workExpData}
            handlePreviousClick={this.handlePreviousClick}
            handleAddQualification={this.handleAddQualification}
            handleAddWorkExp={this.handleAddWorkExp}
            fromMonthYear={fromMonthYear}
            toMonthYear={toMonthYear}
            handleFromMonthYear={this.handleFromMonthYear}
            handleToMonthYear={this.handleToMonthYear}
            handleUpdateDegreeData={this.handleUpdateDegreeData}
            handleUpdateQualification={this.handleUpdateQualification}
            handleUpdateWorkExp={this.handleUpdateWorkExp}
            handleRemoveWorkExp={this.handleRemoveWorkExp}
            handleRemoveDegreeData={this.handleRemoveDegreeData}
            handleRemoveQualification={this.handleRemoveQualification}
          />
        ) : tabIndex === 4 ? (
          <ContactDetails
            contactPerson={contactPerson}
            contactPhone={contactPhone}
            handleContactDetailInputChange={this.handleContactDetailInputChange}
            onCancelClick={BackToTable}
            handleContactDetails={this.handleContactDetails}
            checked={sameWithCtPerson}
            handleSameWithCtPersonChange={this.handleSameWithCtPersonChange}
            guarantor={guarantor}
            guarantorPhone={guarantorPhone}
            selected_gran_NRC_Id={selected_gran_NRC_Id}
            selected_gran_NRC_Category={selected_gran_NRC_Category}
            selected_gran_DistrictCode={selected_gran_DistrictCode}
            gran_nrc_number={gran_nrc_number}
            districtCodeList={granDistrictCodeList}
            nrcList={nrcList}
            nrcCategoryList={nrcCategoryList}
            handleNRC_Id={this.handleNRC_Id}
            handleGranSelectedNRCCategory={this.handleGranSelectedNRCCategory}
            handleGranDistrictCode={this.handleGranDistrictCode}
            handlePreviousClick={this.handlePreviousClick}
            guaFullNRC={guaFullNRC}
          />
        ) : tabIndex === 5 ? (
          <BankAccountDetails
            editForm={editForm}
            viewForm={viewForm}
            handleBankDetailInputChange={this.handleBankDetailInputChange}
            handleSelectedBank={this.handleSelectedBank}
            onCancelClick={BackToTable}
            accountName={accountName.toUpperCase()}
            accountNumber={accountNumber}
            bankList={bankList}
            selected_bank={selected_bank}
            bankData={bankData}
            handleEditBankData={this.handleEditBankData}
            bankDataEdit={bankDataEdit}
            handleAdd_UpdateBankData={this.handleAdd_UpdateBankData}
            handleDeleteBankData={this.handleDeleteBankData}
            handleBankAccountDetails={this.handleBankAccountDetails}
            cancelEdit={this.cancelEdit}
            handlePreviousClick={this.handlePreviousClick}
            employeeNameEng={employeeNameEng}
          />
        ) : tabIndex === 6 ? (
          <OtherInfo
            editForm={editForm}
            onCancelClick={BackToTable}
            viewForm={viewForm}
            handleOtherInfo={this.handleOtherInfo}
            handleOtherInfoInputChange={this.handleOtherInfoInputChange}
            trainingCode={trainingCode}
            partTimeCode={partTimeCode}
            customerCode={customerCode}
            ThaPaYaAccount={ThaPaYaAccount}
            SSCCardNo={SSCCardNo}
            handlePreviousClick={this.handlePreviousClick}
          />
        ) : tabIndex === 7 ? (
          <Attachment
            editForm={editForm}
            viewForm={viewForm}
            handleAttachment={this.handleAttachment}
            handleAttachmentChange={this.handleAttachmentChange}
            attachmentUrl={attachmentUrl}
            onCancelClick={BackToTable}
            handlePreviousClick={this.handlePreviousClick}
          />
        ) : tabIndex === 8 ? (
          <EmploymentDetails
            editForm={editForm}
            viewForm={viewForm}
            employeeStatus={employeeStatus}
            employeeDesignation={employeeDesignation}
            jobTitle={jobTitle}
            carrerLevel={carrerLevel}
            employeeDetailBranch={employeeDetailBranch}
            careerSubLevel={careerSubLevel}
            employedDate={employedDate}
            last_promotion_date={last_promotion_date}
            disConStatus={disConStatus}
            disConDate={disConDate}
            handleEmploymentDetailInputChange={
              this.handleEmploymentDetailInputChange
            }
            handleEmploymentDetail={this.handleEmploymentDetail}
            onCancelClick={BackToTable}
            branchlist={branchlist}
            employeeStatusList={employeeStatusList}
            disConstatusList={disConstatusList}
            handleSelectedEmpStatus={this.handleSelectedEmpStatus}
            level_options={level_options}
            handleSelectedBranch={this.handleSelectedBranch}
            designationList={designationList}
            handleLevelSelectorChange={this.handleLevelSelectorChange}
            handlePreviousClick={this.handlePreviousClick}
            handleSelectedDesignation={this.handleSelectedDesignation}
            handleSelectedDisConStus={this.handleSelectedDisConStus}
          />
        ) : null}
      </div>
    );
  }
}

export default EditEmployeeListForm;
